import { graphql, useStaticQuery } from 'gatsby';
import React, { useState } from 'react';

import ChevronDownSvg from "../assets/icons/chevron-down.svg";
import ChevronRightSvg from "../assets/icons/chevron-right.svg";
import CommandeSvg from "../assets/icons/commande-en-gros.svg";
import DélaisSvg from "../assets/icons/devis-sous-24_H.svg";
import ImpressionSvg from "../assets/icons/impression.svg";


const FAQProductView = () => {

  const data = useStaticQuery(query);
  const [sectionIndex, setSectionIndex] = useState(0);
  const [itemIndex, setItemIndex] = useState(null);

  const faq = [
    {
      title: "Pedidos",
      icon: CommandeSvg,
      children: [
        {
          question: "¿Cuál es el plazo para recibir un presupuesto?",
          answer: "Respuesta en 24 a 48 horas después de la recepción de su solicitud (a veces 1 hora 😁)"
        },
        {
          question: "¿Qué métodos de pago son aceptados?",
          answer: "Tarjeta bancaria, transferencia bancaria, o cheque a la recepción de la factura. También aceptamos bonos de pedido (Chorus)"
        },
        {
          question: "¿Cómo seguir el progreso de mi pedido?",
          answer: "Le informamos por correo electrónico en cada etapa: presupuesto, BAT, producción, envío, entrega"
        },
        {
          question: "¿Proporciona un bon a tirar (BAT)?",
          answer: "Sí, un BAT se proporciona sistemáticamente antes del inicio de la producción. Permite validar el visor final a imprimir"
        },
        {
          question: "¿Hay un mínimo de pedidos?",
          answer: "Sí, mínimo 50 piezas por referencia."
        },
        {
          question: "¿Proporciona descuentos para grandes cantidades?",
          answer: "Sí, nuestros precios son decrecientes según el volumen. Cuanto más pida, menor es el precio por unidad."
        },
        {
          question: "¿Puedo pedir sin impresión?",
          answer: "Sí, es totalmente posible pedir bolsas sin impresión. Por favor, indíquelo al hacer la solicitud."
        },
        {
          question: "¿Qué formato de archivo se debe proporcionar para la impresión?",
          answer: "Recomendamos un archivo vectorial (.ai, .eps, .pdf) para una calidad óptima. Si es necesario, podemos ayudarlo a retocarlo."
        },
        {
          question: "¿Proporciona consejos gráficos o un acompañamiento de diseño?",
          answer: "Sí, nuestro equipo puede ayudarlo a adaptar su visor para un rendimiento óptimo en bolsa (ubicación, color, tamaño, contraste…)."
        }
      ]
    },
    {
      title: "Impressions",
      icon: ImpressionSvg,
      children: [
        {
          question: "¿Qué técnicas de impresión utiliza?",
          answer: "Ofrecemos serigrafía (colores vivos y duraderos), impresión digital (gradientes, fotos), transferencia serigrafía, bordado y bordado 3D"
        },
        {
          question: "¿Cuál es la diferencia entre la serigrafía y la impresión numérica?",
          answer: "La serigrafía es ideal para logos simples y en planos de color (hasta 6 colores), muy resistente en el tiempo. La impresión numérica permite visores complejos, degradados o fotos."
        },
        {
          question: "¿Realiza impresiones en cuatri (cuadrichromía)?",
          answer: "Sí, en particular mediante la impresión numérica, que permite renderings fotográficos realistas en cuatri (CMJN)."
        },
        {
          question: "¿Son las tintas ecológicas?",
          answer: "Sí, utilizamos tintas a base de agua o certificadas OEKO-TEX® STANDARD 100, respetuosas del medio ambiente."
        },
        {
          question: "¿Resisten las impresiones al lavado?",
          answer: "Sí, todas nuestras impresiones se prueban para una buena duración, incluso después de varios lavados. La serigrafía es particularmente durable."
        },
        {
          question: "¿Puedo imprimir en las dos caras?",
          answer: "Sí, puede elegir la impresión recto o recto/reverso según sus necesidades."
        },
        {
          question: "¿Puede hacer un prototipo antes de la orden final?",
          answer: "Sí, podemos producir un prototipo o maqueta virtual antes de la validación"
        }
      ]
    },
    {
      title: "Entrega",
      icon: DélaisSvg,
      children: [
        {
          question: "¿Puedo recibirme en varias direcciones?",
          answer: "Sí, la entrega multi-sitios es posible. Solo necesita proporcionar la distribución deseada al hacer la orden"
        },
        {
          question: "¿Qué transportistas utiliza?",
          answer: "Trabajamos con socios confiables como Colissimo, Chronopost, UPS o DHL, según el tipo de entrega y el destino"
        },
        {
          question: "¿Proporciona un seguimiento de la entrega?",
          answer: "Sí, un número de seguimiento se proporciona tan pronto como el paquete se envía. Puede seguir el envío en tiempo real"
        },
        {
          question: "¿Entrega en Suiza y Reino Unido?",
          answer: "Sí, también entregamos en Suiza y Reino Unido. Por favor, indique su país para un presupuesto ajustado (derechos de aduana eventuales a considerar)"
        },
        {
          question: "¿Puedo elegir una entrega en punto de recogida?",
          answer: "Sí, a solicitud, podemos organizar una entrega en punto de recogida para mayor flexibilidad."
        },
        {
          question: "¿Es la entrega gratuita?",
          answer: "La entrega estándar es gratuita en Francia y Europa para todos los pedidos profesionales, excepto en casos especiales (urgencias o múltiples direcciones)"
        },
        {
          question: "¿Entrega en Europa?",
          answer: "Sí, entrega gratuita en Europa a través de nuestros servicios asociados."
        },
        {
          question: "¿Entrega fuera de Europa?",
          answer: "Sí, contacte con nosotros para un presupuesto adaptado a las zonas afectadas."
        },
        {
          question: "¿Cuál es el plazo de entrega?",
          answer: "Entrega estándar de 10 días laborables después de la validación del BAT y el pago."
        },
        {
          question: "¿Proporciona un servicio express?",
          answer: "Sí, ofrecemos un servicio express (48 a 72 horas de producción) según la factibilidad. Contacte con nosotros en caso de urgencia para beneficiarse"
        }
      ]
    }
  ]


  return <div className='mt-8'>
    <div className="mb-8">
      <h2 className="text-center text-blue font-semibold mb-8">¡FAQ! ¿Necesita ayuda?</h2>
      <div className="grid grid-cols-3 gap-x-4">
        {faq.map((section, i) => <button
          key={section.title}
          onClick={() => { setSectionIndex(i); setItemIndex(null); }}
          className="border:none bg-blue bg-opacity-10 hover:bg-opacity-40 p-4 rounded flex flex-col items-center justify-around">
          <section.icon className="w-20" />
          <h3 className="text-blue m-0 font-semibold">{section.title}</h3>
        </button>
        )}
      </div>

      <ul className="mt-4">
        {faq[sectionIndex].children.map((child, i) => <li key={child.question}>
          <div
            className='cursor-pointer bg-lightGray px-2 py-1 font-bold text-blue mb-4 flex items-center gap-2'
            onClick={() => itemIndex === i ? setItemIndex(null) : setItemIndex(i)}>
            {itemIndex === i ? <ChevronDownSvg className='w-8' /> : <ChevronRightSvg className='w-8' />}
            {child.question}
          </div>
          <p className={`pl-8 text-blue ${itemIndex === i ? 'block' : 'hidden'}`}>{child.answer}</p>
        </li>)}
      </ul>
    </div>



  </div>
}


const query = graphql`
    query {
      image1: file(
      relativePath: {eq: "totebag-faq.jpg" }
      sourceInstanceName: {eq: "uploads" }
      ) {
        childImageSharp {
        gatsbyImageData(width: 300, height: 380) 
      }
    }
     
  }
      `;


export default FAQProductView
